import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Alert } from '@mui/material';

const UnauthorizedPage = ({ redirectTo = '/dashboard' }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(redirectTo);
    }, 3000); // Redirect after 3 seconds
    return () => clearTimeout(timer);
  }, [navigate, redirectTo]);

  return (
    <Container maxWidth="md" sx={{ py: { xs: 2, sm: 3 } }}>
      <Typography variant="h4" gutterBottom sx={{ fontSize: { xs: '1.75rem', md: '2.125rem' } }}>
        Unauthorized Access
      </Typography>
      <Alert severity="error" sx={{ mb: 2 }}>
        You are not authorized to view this page. You will be redirected in 3 seconds.
      </Alert>
    </Container>
  );
};

export default UnauthorizedPage;